import './App.css';
import {Routes, Route, Router, BrowserRouter} from "react-router-dom";
import Home from "./pages/Home";
import {ModalProvider} from "./components/ModalContext";
import "./api";
import PurchaseTicket from "./pages/PurchaseTicket";
import Login from "./pages/Profile/Login";
import ModalContainer from "./components/ModalContainer";
import MushroomAi from "./pages/Mushroom/MushroomAi";
import MushroomGrowth from "./pages/Mushroom/MushroomGrowth";
import BlogList from "./pages/Blog/BlogList";
import BlogInfo from "./pages/Blog/BlogInfo";
import DownloadApp from "./pages/DownloadApp/DownloadApp";
import Company from "./pages/Info/Company";
import Society from "./pages/Info/Society";
import Contact from "./pages/Info/Contact";
import { ToastContainer, Bounce } from 'react-toastify';
import Profile from "./pages/Profile/Profile";
import Subscriptions from "./pages/Profile/Subscriptions";
import TicketsUser from "./pages/Profile/TicketsUser";

function App() {
    return (
        <ModalProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/buy" element={<PurchaseTicket/>}/>
                    <Route path="/buy/:id" element={<PurchaseTicket/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/mushroom-growth-table" element={<MushroomGrowth/>}/>
                    <Route path="/ai" element={<MushroomAi/>}/>
                    <Route path="/blog" element={<BlogList/>}/>
                    <Route path="/blog/:sku" element={<BlogInfo/>}/>
                    <Route path="/download-app" element={<DownloadApp/>}/>
                    <Route path="/company" element={<Company/>}/>
                    <Route path="/society" element={<Society/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                    <Route path="/user/account" element={<Profile/>}/>
                    <Route path="/user/subscriptions" element={<Subscriptions />}/>
                    <Route path="/user/tickets" element={<TicketsUser />}/>
                </Routes>
            </BrowserRouter>
            <ModalContainer/>
<ToastContainer position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}/>
        </ModalProvider>
    );
}

export default App;
